export default function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rrc/es/helpers/getDisplayName.js
// module id = 79
// module chunks = 0